import { useSnackbar } from "notistack";

export default function useNotification() {
  const { enqueueSnackbar } = useSnackbar();

  const showNotification = (msg, variant, vertical, horizontal,) => {
    enqueueSnackbar(msg, {
      variant: variant || "success",
      anchorOrigin: {
        vertical: vertical || "bottom",
        horizontal: horizontal || "right",
      },
    }, { autoHideDuration: 1000 });
  };

  return {
    showNotification,
  };
}
